import React from "react";
import styles from "./ScrollBar.module.css";




function ScrollBar(props) {
  const { body, BottomSpace, height } = props;
  return (

    <div className={styles.ScrollBar} style={{maxHeight:height}}>
      <div className={styles.ScrollBarInner} style={{paddingBottom:BottomSpace}}>
        {body}
      </div>
    </div>
  )
}


export default ScrollBar;

